import type { SxProps, Theme } from "@mui/material/styles";

export const actionLink =
  (fullWidth: boolean): SxProps<Theme> =>
  () => ({
    textDecoration: "none",
    flexShrink: 0,
    ...(fullWidth ? { width: "100%" } : {}),
  });

export const button: SxProps<Theme> = {
  fontWeight: 700,
  borderRadius: 1.5,
  whiteSpace: "nowrap",
};

export const contactOwner: SxProps<Theme> = {
  fontSize: "0.75rem",
  fontWeight: 700,
  color: "text.secondary",
  lineHeight: 1.7,
};
